import { IInformationState } from './Information.types';
import { IInformationActions, ActionTypes } from './Information.action-types';
import { toast } from 'react-toastify';

export const INITIAL_INFORMATION: IInformationState = {
    name: '',
    emailName: '',
    apiUpdateStatus: false,
    perner: 0,
    subgroup: '',
    status: '',
    payPeriod: '',
    isAdmin: false,
    salaried: false,
    hrPersonSubGroupCode: '',
    effectiveStartDate: new Date(2019, 11, 11),
    hireDate: new Date(2019, 11, 11),
    payCycleCode: '',
    tarUser: undefined,
    wob: false,
    companyCode: '',
    costCenterCode: '',
    adminRoleTypeCode: 0,
    untrackedUser: false,
    isFormerTARUser: undefined,
    isTARManager: undefined,
    dtoEnabled: false,
    dcopsBannerFlag: false
};

export function informationReducer(
    state: IInformationState = INITIAL_INFORMATION,
    action: IInformationActions
): IInformationState {
    switch (action.type) {
        case ActionTypes.INFORMATION_SUCCEEDED:
            return action.data;
        case ActionTypes.INFORMATION_FAILED:
            toast.error(action.errorMsg, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 9000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined
            });
            return state;
        case ActionTypes.INFORMATION_SET_APIUPDATESTATE:
            return {
                ...state,
                apiUpdateStatus: action.data
            };
        default:
            return state;
    }
}
